import { render } from "./ReportProductException.vue?vue&type=template&id=9a64a752&scoped=true&ts=true"
import script from "./ReportProductException.vue?vue&type=script&lang=ts"
export * from "./ReportProductException.vue?vue&type=script&lang=ts"

import "./ReportProductException.vue?vue&type=style&index=0&id=9a64a752&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/saas-pim-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a64a752"]])

export default __exports__